import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const routes = [
    '/administracao/logs', // SSE (Server Sent Events)
    '/administracao/logs/hoje',
    '/administracao/logs/ontem',
    '/administracao/logs/semana',
    '/administracao/logs/mes',
    '/administracao/logs/ano',
]

const ToolbarLog = () => {
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const [value, setValue] = React.useState(() => {
        const index = routes.findIndex(route => route === pathname)
        return index === -1 ? 0 : index
    })

    const handleNavigate = (index: number) => {
        return setTimeout(() => {
            navigate(routes[index])
        }, 380)
    }

    function handleChange(_event: React.SyntheticEvent, newValue: number) {
        setValue(newValue)
    }

    React.useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>

        if (pathname !== routes[value]) {
            timeout = handleNavigate(value)
        }
        ;() => clearTimeout(timeout)
    }, [value])

    return (
        <>
            <div style={{ flex: 1 }} />
            <Tabs value={value} onChange={handleChange}>
                <Tab label="Agora" {...a11yProps(0)} />
                <Tab label="Hoje" {...a11yProps(1)} />
                <Tab label="Ontem" {...a11yProps(2)} />
                <Tab label="Esta Semana" {...a11yProps(3)} />
                <Tab label="Este Mês" {...a11yProps(4)} />
                <Tab label="Este Ano" {...a11yProps(5)} />
            </Tabs>
        </>
    )
}

function a11yProps(index: number) {
    return {
        id: `logs-tab-${index}`,
        'aria-controls': `logs-tabpanel-${index}`,
        sx: { width: 130 },
    }
}

export default ToolbarLog
